import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import { AnalyticsEvent } from '../../../models/analytics-event.interface';

import { TooltipDirective } from '@com-delta-omnichannel/aura';
import { SingleCard } from '../mocks/cards.mocks';
import {
  SkyClubCard,
  TooltipInfo,
  TrackerFooter
} from '../models/skyclub.interfaces';
import { SkyclubSpendTrackerFooterComponent } from '../skyclub-spend-tracker-footer/skyclub-spend-tracker-footer.component';

@Component({
  selector: 'idp-skyclub-spend-tracker-card',
  standalone: true,
  imports: [CommonModule, TooltipDirective, SkyclubSpendTrackerFooterComponent],
  templateUrl: './skyclub-spend-tracker-card.component.html',
  styleUrls: ['./skyclub-spend-tracker-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SkyclubSpendTrackerCardComponent implements OnChanges {
  @Input() content: SkyClubCard[] = SingleCard as SkyClubCard[];
  @Input() carouselIndex = 0;
  @Output() skyclubTrackerClick = new EventEmitter<AnalyticsEvent>();
  progressValue = 0;

  constructor() {
    this.initializeProgressValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.handleCarouselIndexChange(changes);
  }

  public initializeProgressValue(): void {
    this.progressValue = this.getProgressValueForCurrentIndex();
  }

  public handleCarouselIndexChange(changes: SimpleChanges): void {
    if (!this.hasCarouselIndexChanged(changes)) {
      return;
    }

    this.progressValue = this.getProgressValueForCurrentIndex();
  }

  public hasCarouselIndexChanged(changes: SimpleChanges): boolean {
    if (!changes['carouselIndex']) {
      return false;
    }

    const { previousValue, currentValue } = changes['carouselIndex'];
    return previousValue !== currentValue;
  }

  public getProgressValueForCurrentIndex(): number {
    const currentVisit = this.content[this.carouselIndex]?.visit;
    return currentVisit?.count ? this.calculateProgress(currentVisit.count) : 0;
  }

  public calculateProgress(count: number): number {
    return (count / this.content[this.carouselIndex].visit.maxCount) * 100;
  }

  onTermsLinkClick(card: SkyClubCard, cardIndex: number, type: string): void {
    const eventData = {
      id: `skyclub_tracker_${cardIndex}`,
      name: card.type.terms.label || 'SkyClub Terms Link',
      eventName: 'skymiles overview - delta sky club tracker - click',
      position: '1 of 1',
      link:
        type === 'tooltip'
          ? 'Card Descriptor tooltip view'
          : card.type.terms.url,
      type: 'award',
      pageSection: 'banner:delta sky club tracker:card descriptor',
      component_type: 'banner',
      component_name: 'Delta Sky Club Tracker'
    };

    this.skyclubTrackerClick.emit({
      eventName:
        type === 'tooltip' ? type : 'skyclub spend tracker terms click',
      eventData: JSON.stringify(eventData)
    });
  }

  onSearchEligibleClick(
    type: string,
    index: number,
    content: TrackerFooter | TooltipInfo | undefined
  ): void {
    const eventData = {
      id: `skyclub_tracker_${index}`,
      eventName: 'skymiles overview - delta sky club tracker - click',
      name: (content as TooltipInfo).label || 'Search Eligible Footer',
      position: '1 of 1',
      link:
        type === 'tooltip'
          ? 'Total Spend tooltip view'
          : (content as TooltipInfo).url,
      type: 'award',
      pageSection: 'banner:delta sky club tracker:total spend',
      component_type: 'banner',
      component_name: 'Delta Sky Club Tracker'
    };

    this.skyclubTrackerClick.emit({
      eventName: type === 'tooltip' ? type : 'Search eligible Sky Clubs',
      eventData: JSON.stringify(eventData)
    });
  }
}
